import { Typography } from "@mui/material";
import { ACTIVITY_CHANGE } from "./activityConstants";
import { formatTextOrDate } from "./activityHelpers";

export default function ActivityChangeDescription({
  type,
  oldVal,
  newVal,
}: Readonly<{
  type: ACTIVITY_CHANGE;
  oldVal?: string;
  newVal?: string;
}>) {
  const HighlightedValue = ({ value, label }: { value?: string; label: string }) => (
    <Typography
      component="span"
      variant="caption"
      sx={{ fontWeight: "bold", color: "text.primary" }}
      aria-label={`${label}: ${formatTextOrDate(value)}`}
    >
      <strong>{formatTextOrDate(value)}</strong>
    </Typography>
  );

  const getDescription = () => {
    if (type === ACTIVITY_CHANGE.Added) {
      return (
        <>Added value <HighlightedValue value={newVal} label="New value" /></>
      );
    }
    if (type === ACTIVITY_CHANGE.Removed) {
      return (
        <>Removed value: <HighlightedValue value={oldVal} label="Old value" /></>
      );
    }
    return (
      <>
        Changed from <HighlightedValue value={oldVal} label="Old value" /> to{" "}
        <HighlightedValue value={newVal} label="New value" />
      </>
    );
  };

  return (
    <Typography
      component="span"
      variant="body2"
      role="status"
      aria-live="polite"
      sx={{ display: "inline" }}
    >
      {getDescription()}
    </Typography>
  );
}
